import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { take } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import { FeatureSpecSelectors } from '@core/feature-spec-data';
import { FeatureCode } from '@core/feature-spec-types';
import type { Location } from '@core/locations-types';

@Injectable({ providedIn: 'root' })
export class LocationsHelperService {
  private readonly store = inject(Store);

  public getLocationsLimit() {
    return this.store.select(FeatureSpecSelectors.forCode(FeatureCode.Locations)).pipe(
      filterBoolean,
      map(({ configuration }) => configuration.limit ?? Number.POSITIVE_INFINITY),
      take(1),
    );
  }

  public isLocationsUpdated(currentLocations: Location[] | undefined, newLocations: Location[]) {
    if (!currentLocations) return !!newLocations.length;
    if (currentLocations.length !== newLocations.length) return true;

    const currentLocationsIds = new Set(currentLocations.map(location => location.id));
    const newLocationsIds = new Set(newLocations.map(location => location.id));

    currentLocations.forEach(location => {
      newLocationsIds.delete(location.id);
      currentLocationsIds.delete(location.id);
    });
    return newLocationsIds.size !== 0 || currentLocationsIds.size !== 0;
  }
}
